import React from 'react';
import TooltipsContainer from '../../Componant/UiKits/Tooltip';

const Tooltips = () => {
  return (
    <div className='page-body'>
      <TooltipsContainer />
    </div>
  );
};

export default Tooltips;
